import clsx from 'clsx';
import { useRef, useState } from 'react';
import { OtpInput as BaseOtpInput } from 'reactjs-otp-input';

export interface OtpInputProps {
  name: string;
  isSecure?: boolean;
  length?: number;
  inputType?: 'numeric' | 'text' | 'alphanumeric';
  onComplete?: (otp: string) => void;
  onChange?: (value: string) => void;
  value?: string;
}

function OtpInput({
  name,
  isSecure = false,
  length = 4,
  inputType = 'numeric',
  onChange,
  onComplete,
}: OtpInputProps) {
  const [value, setValue] = useState('');
  const containerRef = useRef<HTMLDivElement>(null);

  const cleanValue = (str: string): string => {
    if (inputType === 'numeric') {
      return str.replace(/\D/g, '');
    }
    if (inputType === 'alphanumeric') {
      return str.replace(/[^a-zA-Z0-9]/g, '');
    }
    return str;
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const cleanedText = cleanValue(pastedText).slice(0, length);

    setValue(cleanedText);
    if (onChange) onChange(cleanedText);
    if (cleanedText.length === length && onComplete) {
      onComplete(cleanedText);
    }
  };

  return (
    <div ref={containerRef} onPaste={handlePaste}>
      <BaseOtpInput
        numInputs={length}
        onChange={function (otp: string): void {
          const cleanedOtp = cleanValue(otp);
          setValue(cleanedOtp);
          if (onChange) onChange(cleanedOtp);
          if (cleanedOtp.length === length && onComplete) {
            onComplete(cleanedOtp);
          }
        }}
        isInputNum={inputType === 'numeric'}
        isInputSecure={isSecure}
        inputStyle={clsx(
          'form-control bg-transparent fs-2qx text-center mx-1 my-2',
          {
            'h-60px w-60px': length <= 6,
            'h-45px w-45px': length > 6 && length <= 8,
            'h-35px w-35px': length > 8
          }
        )}
        data-cy={`input-${name}`}
        value={value}
      />
    </div>
  );
}

export default OtpInput;
